import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Grid, Row, Col, Well } from 'react-bootstrap'
import { getUserCompanyOnLock } from '../../common/utils'
import MessageGroupUser from './MessageGroupUser'
import ChooseLockUserModal from '../../common/components/ChooseLockUserModal'
import { createOrUpdateUsersGroup, removeUserAccesses, getMessageGroups } from './actions'

class LogistikareView extends Component {
    constructor(props) {
        super(props)
    }

    state = { showChooseLockuserModal: false, messageGroups: null }

    replaceMessageGroup = (group) => {
        let messageGroups = []
        if (!this.state.messageGroups.length) {
            messageGroups.push(group)
        } else {
            messageGroups = this.state.messageGroups.map(g => {
                if (g._id === group._id) return group

                return g
            })
        }

        this.setState({ messageGroups })
    }

    addMessageGroup = (newGroup) => {
        this.setState({ messageGroups: (this.state.messageGroups || []).concat(newGroup) })
    }

    componentWillMount() {
        getMessageGroups(this.props.lock._id).then(t => {
            this.setState({ messageGroups: t.messageGroups.filter(g => g.groupType === "logistikare") })
        })
    }

    lockUsersChoosen = ({ customerIds, selectedCompanies }) => {
        if (!customerIds || !customerIds.length) return this.setState({ showChooseLockuserModal: false })

        const { lock } = this.props
        // const groupId = this.state.messageGroups && this.state.messageGroups.length ? this.state.messageGroups[0]._id : null
        const groupId = null
        createOrUpdateUsersGroup(lock._id, customerIds, { groupType: 'logistikare', groupName: 'Logistikarna', _id: groupId, selectedCompanies }).then(t => {
            // this.replaceMessageGroup(t)
            this.addMessageGroup(t)
        })
    }

    removeUserAccesses = (accessIds) => {
        removeUserAccesses(accessIds).then(t => {
            this.setState({
                messageGroups: this.state.messageGroups.map(group => {
                    const value = t[group._id]

                    if (value === undefined) return group // ej uppdaterad
                    if (value === null) return null // raderad

                    return value // nytt värde
                }).filter(g => !!g)
            })
        })
    }

    render() {
        const { keyedCustomers, lock } = this.props
        const { messageGroups } = this.state

        return (
            <div style={this.props.style}>
                {this.state.showChooseLockuserModal ? <ChooseLockUserModal allowChooseCompanies={true} sendResults={this.lockUsersChoosen} lock={lock} closeModal={() => this.setState({ showChooseLockuserModal: false })} /> : null}

                <Grid style={{ maxWidth: '100%' }}>
                    <Row>
                        <Col lg={12}>
                            <Well>Arbetsplatser som vill att en, eller flera, personer ska få en avisering på alla leveranser oavsett företag som får leveranser till sig. Den här funktionen är vanlig hos de arbetsplatser som har en logistikare
                            som hanterar alla leveranser åt alla företagen på arbetsplatsen.
                            </Well>
                        </Col>
                    </Row>

                    <br />

                    <Row>
                        <Col lg={3}>
                            <span style={{ fontSize: 20 }}>Vem/vilka är logistikare?</span>
                        </Col>
                        <Col lg={9} style={{ textAlign: 'left' }}>
                            <span className="qLink" onClick={() => this.setState({ showChooseLockuserModal: true })}>+ Lägg till</span>
                        </Col>
                    </Row>

                    <br />

                    <Row>
                        <Col lg={12}>
                            {!messageGroups ? 'Laddar' :
                                messageGroups.map(group => {
                                    const selectedCompaniesNames = this.props.companies.filter(c => (group.selectedCompanies || []).some(sc => c._id === sc)).map(c => c.name)

                                    return group.users.map((user, i) => {
                                        const customer = keyedCustomers[user.customer]
                                        if (!customer) return null

                                        const company = getUserCompanyOnLock(lock._id, customer._id)

                                        return (
                                            <MessageGroupUser
                                                key={i}
                                                customer={customer}
                                                company={company}
                                                removeUserAccesses={this.removeUserAccesses}
                                                groupUserId={user._id}
                                                selectedCompaniesNames={selectedCompaniesNames}
                                            />
                                        )
                                    })
                                })
                            }
                        </Col>
                    </Row>
                </Grid>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        keyedCustomers: state.collectionData.keyedCustomers,
        messageGroups: state.collectionData.messageGroups,
        companies: state.collectionData.companies.companies
    }
}

const mapDispatch = (dispatch) => {
    return {
        // createOrUpdateUsersGroup: (...p) => dispatch(createOrUpdateUsersGroup(...p)),
        // getMessageGroups: (...p) => dispatch(getMessageGroups(...p))
    }
}

export default connect(mapStateToProps, mapDispatch)(LogistikareView)